'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.switchLocale = exports.switchCurrency = exports.updateIntl = exports.getLocale = exports.UPDATE = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _reactIntl = require('@liveauctioneers/react-intl');

var _reselect = require('reselect');

var _en = require('../../intl/en');

var _en2 = _interopRequireDefault(_en);

var _flattenMessages = require('../../utils/flattenMessages');

var _flattenMessages2 = _interopRequireDefault(_flattenMessages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var UPDATE = exports.UPDATE = '@@intl/UPDATE';

/* reducer */
var DEFAULT_STATE = {
    locale: 'en',
    messages: {}
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case UPDATE:
            return (0, _extends3.default)({}, state, action.payload);
        default:
            return state;
    }
}

/* SELECTORS */
var intlSelector = (0, _reselect.createSelector)(function (state) {
    return state;
}, function (s) {
    return s.intl;
});

var getLocale = exports.getLocale = (0, _reselect.createSelector)(intlSelector, function (intl) {
    return intl.locale || 'en';
});

var getIntlMessages = function getIntlMessages(locale) {
    var newLocaleData = require('@liveauctioneers/react-intl/locale-data/' + locale);
    (0, _reactIntl.addLocaleData)(newLocaleData);

    var flatFallback = (0, _flattenMessages2.default)(_en2.default);

    var newLanguage = require('../../intl/' + locale);
    var flatMessages = (0, _flattenMessages2.default)(newLanguage);
    return (0, _extends3.default)({}, flatFallback, flatMessages);
};

/* ACTION CREATORS */
var updateIntl = exports.updateIntl = function updateIntl(_ref) {
    var locale = _ref.locale,
        formats = _ref.formats,
        messages = _ref.messages;
    return {
        payload: { formats: formats, locale: locale, messages: messages },
        type: UPDATE
    };
};

var switchCurrency = exports.switchCurrency = function switchCurrency(currency) {
    return {
        type: 'CHANGE_CURRENCY'
    };
};

var switchLocale = exports.switchLocale = function switchLocale(locale) {
    return function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var messages;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            try {
                                messages = getIntlMessages(locale);

                                dispatch(updateIntl({
                                    locale: locale,
                                    messages: messages
                                }));
                            } catch (error) {}

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined);
        }));

        return function (_x3, _x4) {
            return _ref2.apply(this, arguments);
        };
    }();
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/intl.js
// module id = dYLj
// module chunks = 60